import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Building2, ListFilter, Phone } from 'lucide-react';
import { useTranslation } from '../contexts/LanguageContext';
import { useMarket } from '../contexts/MarketContext';

export default function MobileBottomNav() {
  const location = useLocation();
  const { t } = useTranslation();
  const { marketLink, marketPathPrefix } = useMarket();

  // Hide on admin pages
  if (location.pathname.startsWith('/admin') || location.pathname === '/login') return null;

  const tabs = [
    { href: marketLink('/'), matchPath: marketPathPrefix || '/', icon: Home, label: t('nav.home') },
    { href: marketLink('/properties'), matchPath: `${marketPathPrefix}/properties`, icon: Building2, label: t('nav.projects') },
    { href: marketLink('/listings'), matchPath: `${marketPathPrefix}/listings`, icon: ListFilter, label: t('nav.listings') },
    { href: marketLink('/contact'), matchPath: `${marketPathPrefix}/contact`, icon: Phone, label: t('nav.contact') },
  ];

  const isActive = (matchPath) => matchPath === '/' || matchPath === marketPathPrefix
    ? location.pathname === matchPath
    : location.pathname.startsWith(matchPath);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/95 backdrop-blur-sm border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-1">
        {tabs.map(tab => {
          const active = isActive(tab.matchPath);
          return (
            <Link key={tab.href} to={tab.href}
              className={`flex flex-col items-center gap-0.5 px-4 py-2 rounded-xl transition-all min-w-0 ${
                active
                  ? 'text-[#1B5E37]'
                  : 'text-muted-foreground hover:text-foreground'
              }`}>
              <tab.icon className={`w-5 h-5 transition-transform ${active ? 'scale-110' : ''}`} />
              <span className={`text-[10px] font-medium truncate ${active ? 'text-[#1B5E37]' : ''}`}>
                {tab.label}
              </span>
              {active && (
                <span className="w-1 h-1 rounded-full bg-[#1B5E37] mt-0.5" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
